const MastersTypes = {
  AREATYPE: 'areaTypeMaster',
  DISTRICT: 'districtMaster',
  TALUKA: 'talukaMaster',
  PHC: 'phcMaster',
  UPHC: 'uphcMaster',
  SUBCENTER: 'subcenterMaster',
  VILLAGE: 'villageMaster',
  SUBAREA: 'subareaMaster',
  ROLE: 'roleMaster',
  USER: 'userMaster',
  BANK: 'bankMaster',
  BANK_BRANCH:'bankBranchMaster',
  TRAINING: 'trainingMaster',
  FACULTY: 'facultyMaster',
  TRAINING_CALENDAR: 'trainingCalendarMaster',
  PROGRAM: 'programMaster',
  SCHEME: 'schemeMaster',
  ACTIVITY: 'activityMaster',
  GOVERNINGBODY: 'localgoverningbodymaster',
  CORPORATION: 'corporation_coucil_master'
};

Object.freeze(MastersTypes);

export default MastersTypes;
